import PropTypes from "prop-types";

const SEGMENT_COLORS = {
  completed: "tw-bg-theme-brand",
  in_progress: "tw-bg-theme-brand-lighter",
};

const MilestoneProgressBar = ({ milestones = [] }) => (
  <div className="tw-flex tw-gap-[4px] tw-pt-[12px]">
    {milestones.map((m) => (
      <div
        key={m.key}
        className={`tw-flex-1 tw-h-[4px] tw-rounded-full ${SEGMENT_COLORS[m.status] || "tw-bg-neutral-gray-5"}`}
      />
    ))}
  </div>
);

MilestoneProgressBar.propTypes = {
  milestones: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ),
};

export default MilestoneProgressBar;
